import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";
import { api, FEATURE_LABELS, money } from "@/lib/api";

export default function PlanGate({ feature, title }) {
  const label = title || FEATURE_LABELS[feature] || "Este recurso";
  const [info, setInfo] = useState(null);
  useEffect(() => {
    if (feature) api.get(`/me/upgrade-info?feature=${feature}`).then((r) => setInfo(r.data)).catch(() => {});
  }, [feature]);

  const up = info?.upgrade_plan;
  return (
    <div data-testid="plan-gate" className="max-w-lg mx-auto mt-16 bg-[#121217] border border-white/[0.06] rounded-sm p-8 text-center">
      <div className="h-12 w-12 rounded-sm bg-[#FF4D00]/10 border border-[#FF4D00]/30 flex items-center justify-center mx-auto mb-4"><Lock className="h-6 w-6 text-[#FF4D00]" /></div>
      <h2 className="font-head text-2xl font-bold" data-testid="plan-gate-title">{label}</h2>
      <p className="text-zinc-400 text-sm mt-2" data-testid="plan-gate-reason">
        {info ? <>"{label}" não está disponível no <b>Plano {info.current_plan?.name}</b>.</> : "Este recurso não está incluído no seu plano atual."}
      </p>
      {up && (
        <p className="text-sm text-[#FFBF00] mt-2" data-testid="plan-gate-upgrade-line">
          Disponível a partir do <b>Plano {up.name}</b> por <b>{up.price > 0 ? `${money(up.price)}/mês` : "grátis"}</b>.
        </p>
      )}
      <Link to="/meu-plano" data-testid="plan-gate-upgrade" className="inline-flex items-center gap-2 mt-5 px-4 py-2.5 rounded-sm bg-[#FF4D00] hover:bg-[#E64500] text-white text-sm font-semibold">
        <Crown className="h-4 w-4" />{up ? `Fazer upgrade para ${up.name}` : "Ver planos"}
      </Link>
    </div>
  );
}
